/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ScheduledPruneDto } from '../models/ScheduledPruneDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RemoteParticipantPruneControllerService {

    /**
     * @param name
     * @returns ScheduledPruneDto OK
     * @throws ApiError
     */
    public static getRemoteParticipantPruningSchedule(
        name: string,
    ): CancelablePromise<ScheduledPruneDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/remote-participants/{name}/prune',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @param requestBody
     * @returns any Created
     * @throws ApiError
     */
    public static createRemoteParticipantPruningSchedule(
        name: string,
        requestBody: ScheduledPruneDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/remote-participants/{name}/prune',
            path: {
                'name': name,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns void
     * @throws ApiError
     */
    public static deleteRemoteParticipantPruningSchedule(
        name: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/remote-participants/{name}/prune',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
